import { SegmentedControl } from '@radix-ui/themes';
import { useActiveRoute } from 'hooks/useActiveRoute';
import { t } from 'i18next';
import { ISubSection } from 'interfaces/i-section';
import { useNavigate } from 'react-router-dom';

export const SubSectionSelector = (props: { subsections: ISubSection[] }) => {
  const navigate = useNavigate();
  const { subsection } = useActiveRoute();

  return (
    <SegmentedControl.Root value={subsection}>
      {props.subsections
        .filter((s) => !s.invisible)
        .map((s, i) => (
          <SegmentedControl.Item
            key={`subsection-${i}`}
            value={s.value}
            className="cursor-pointer"
            onClick={() => {
              navigate(s.to);
            }}
          >
            {t(s.label)}
          </SegmentedControl.Item>
        ))}
    </SegmentedControl.Root>
  );
};
